import { useTranslation } from 'react-i18next';
import { User, UserX } from 'lucide-react';
import { PropertyRow } from '@/shared/components/ui/PropertyRow';
import { ChipToggle } from '@/shared/components/ui/ChipToggle';

interface AnonymousToggleProps {
  value: boolean;
  onChange: (value: boolean) => void;
}

export const AnonymousToggle = ({ value, onChange }: AnonymousToggleProps) => {
  const { t } = useTranslation('knowledge');

  return (
    <PropertyRow
      icon={<UserX />}
      label={t('anonymousLabel')}
      tooltip={t('anonymousTooltip')}
    >
      <ChipToggle
        options={[
          {
            value: 'show',
            label: t('showMyName'),
            icon: <User />,
            activeColor: {
              bg: 'bg-green-600/8',
              text: 'text-green-800',
              border: 'border-green-600/25',
              iconColor: 'text-green-600',
            },
          },
          {
            value: 'anonymous',
            label: t('anonymous'),
            icon: <UserX />,
            activeColor: {
              bg: 'bg-indigo-600/8',
              text: 'text-indigo-700',
              border: 'border-indigo-600/25',
              iconColor: 'text-indigo-600',
            },
          },
        ]}
        value={value ? 'anonymous' : 'show'}
        onChange={(selected) => onChange(selected === 'anonymous')}
      />
    </PropertyRow>
  );
};
